import { render, staticRenderFns } from "./AddAnotherProject-View.vue?vue&type=template&id=32f07cd1&scoped=true&"
import script from "./AddAnotherProject-View.vue?vue&type=script&setup=true&lang=js&"
export * from "./AddAnotherProject-View.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./AddAnotherProject-View.vue?vue&type=style&index=0&id=32f07cd1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f07cd1",
  null
  
)

export default component.exports